import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { Rating as RatingWidget } from "widgets/inputs";

import { Base } from "../base";

import styles from "./rating.css";

export function Rating(props) {
  const { column, value, pos, row } = props;
  const baseRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value);

  useEffect(
    function onValueChange() {
      setCurrentValue(value || null);
    },
    [value, row, pos]
  );

  return (
    <Base
      {...props}
      ref={baseRef}
      onEditing={(value) => {
        if (value >= 0 && value <= 5) {
          baseRef.current.startEditing(parseInt(value, 10));
          baseRef.current.dataChanged(parseInt(value, 10));
          baseRef.current.dataCompleted();
        }
      }}
      className={styles.rating}
      type="starrating"
    >
      <RatingWidget
        value={currentValue}
        readOnly={column.readOnly}
        handleChange={(value) => {
          setCurrentValue(value);
          baseRef.current.startEditing(value);
          baseRef.current.dataChanged(value);
          baseRef.current.dataCompleted();
        }}
      />
    </Base>
  );
}

Rating.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  row: PropTypes.any,
  pos: PropTypes.any
};
